import { useLanguage as useLanguageContext } from '../contexts/LanguageContext';
import { translations } from '../i18n/index';

export function useLanguage() {
    const { lang, setLang } = useLanguageContext();

    const t = translations[lang];

    return { language: lang, setLanguage: setLang, t };
}
